import { Tooltip, IconButton } from '@mui/material';
import { GridRenderCellParams, GridRowModel } from '@mui/x-data-grid';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function shallowEqual(objA: Record<string, unknown>, objB: Record<string, unknown>): boolean {
  if (objA === objB) return true;
  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;
  for (const key of keysA) {
    if (objA[key] !== objB[key]) return false;
  }
  return true;
}

export function renderCellWithDashDefault(
  params: GridRenderCellParams<GridRowModel, unknown>,
  onReset?: (row: GridRowModel) => void,
  isValid: boolean = true,
  invalidMessage: string = 'Invalid value'
) {
  const confidenceScore = params.row[`${params.colDef.field}_confidence`];
  const explanation = params.row[`${params.colDef.field}_explanation`];
  const original = params.row[`${params.colDef.field}_original`];
  const current = params.row[params.colDef.field];
  const isEditable = params.colDef.editable !== false; // Check if column is editable

  let hasBeenEdited: boolean;
  if (typeof original === 'object' && original !== null && typeof current === 'object' && current !== null) {
    hasBeenEdited = !shallowEqual(original, current);
  } else if (typeof original === 'object' && original !== null && typeof current === 'object' && current === null) {
    hasBeenEdited = true;
  } else {
    hasBeenEdited = original !== current;
  }

  const content = params.formattedValue ? (
    <span style={{ width: '100%', display: 'inline-block', textOverflow: 'ellipsis' }}>
      {String(params.formattedValue)}
    </span>
  ) : (
    <span style={{ textAlign: 'center', width: '100%', display: 'inline-block' }}>-</span>
  );
  const resetButton = (
    <Tooltip title="Reset value">
      <IconButton
        style={{ position: 'absolute', right: 0, top: 0, marginRight: -10, padding: 0 }}
        onClick={() => {
          params.api.updateRows([
            {
              id: params.id,
              [params.colDef.field]: params.row[`${params.colDef.field}_original`]
            }
          ]);
          if (onReset) {
            onReset({ ...params.row, [params.colDef.field]: params.row[`${params.colDef.field}_original`] });
          }
        }}>
        <span className="corner-triangle-icon" />
      </IconButton>
    </Tooltip>
  );
  const invalidIcon = (
    <Tooltip title={invalidMessage}>
      <ErrorOutlineIcon
        color="error"
        style={{
          position: 'absolute',
          marginLeft: -5,
          left: 0,
          top: 0,
          width: 20,
          height: 20,
          zIndex: 2
        }}
        fontSize="small"
      />
    </Tooltip>
  );
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {!isValid && invalidIcon}
      {hasBeenEdited && isEditable && resetButton}
      <Tooltip
        title={
          confidenceScore || explanation ? (
            <div>
              {confidenceScore !== undefined && <div>Score: {confidenceScore}</div>}
              {explanation && (
                <>
                  <br />
                  <div>{explanation}</div>
                </>
              )}
            </div>
          ) : (
            ''
          )
        }
        disableHoverListener={!confidenceScore && !explanation}>
        <span>{content}</span>
      </Tooltip>
    </div>
  );
}
